'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UISliderTickMark = function UISliderTickMark(_ref) {
  var className = _ref.className,
      currentSliderValue = _ref.currentSliderValue,
      value = _ref.value,
      min = _ref.min;

  return _react2.default.createElement('div', {
    className: (0, _classNames2.default)(className, 'private-slider__tickmark', {
      'private-slider__tickmark--left': value <= currentSliderValue,
      'private-slider__tickmark--filled': min <= value && value <= currentSliderValue
    })
  });
};

UISliderTickMark.propTypes = {
  currentSliderValue: _react.PropTypes.number,
  value: _react.PropTypes.number,
  min: _react.PropTypes.number
};

UISliderTickMark.displayName = 'UISliderTickMark';

exports.default = UISliderTickMark;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/internal/UISliderTickMark.js
// module id = 664
// module chunks = 3 4